module.exports = __webpack_public_path__ + "static/media/result-history-icon.a38494a9.png";